import React from "react";
import DynamicIsland from "../components/DynamicIsland";
import CurrentTime from "../components/CurrentTime";
import Back from "../components/Back";
import './CampusLife.css';

function CampusLife(){
    return(
        <div className="campus-life-container">
            <CurrentTime/>
            <DynamicIsland/>
            <Back/>

            <div className="campus-life-wrapper">
                <h1>TU Tiger Ride</h1>
                <iframe
                src="https://www.tutigerride.com/map"
                width="450px"
                height="500px"
                className="tiger-ride-map"
                >    
                </iframe>
            </div>
        </div>
    );
}

export default CampusLife;